module.exports = __webpack_public_path__ + "static/media/gmad-grupo-logo.1420b970.svg";